export default {
  permission: [],
  timer: 300000,
  groups: [],
  group: [],
  listPerm: [],
  listUser: [],
  compExpire: [],
  compSoldOut: [],
  setPriceCost: []
}